__turbopack_context__.v({
  "dotSep": "LiveActivity-module__1rXE0a__dotSep",
  "empty": "LiveActivity-module__1rXE0a__empty",
  "fault": "LiveActivity-module__1rXE0a__fault",
  "list": "LiveActivity-module__1rXE0a__list",
  "message": "LiveActivity-module__1rXE0a__message",
  "panel": "LiveActivity-module__1rXE0a__panel",
  "panel-in": "LiveActivity-module__1rXE0a__panel-in",
  "panelHead": "LiveActivity-module__1rXE0a__panelHead",
  "panelNote": "LiveActivity-module__1rXE0a__panelNote",
  "panelTitle": "LiveActivity-module__1rXE0a__panelTitle",
  "pill": "LiveActivity-module__1rXE0a__pill",
  "pill-pulse": "LiveActivity-module__1rXE0a__pill-pulse",
  "pillDot": "LiveActivity-module__1rXE0a__pillDot",
  "pillDotOffline": "LiveActivity-module__1rXE0a__pillDotOffline",
  "pillDotStale": "LiveActivity-module__1rXE0a__pillDotStale",
  "pillDotSyncing": "LiveActivity-module__1rXE0a__pillDotSyncing",
  "pillOpen": "LiveActivity-module__1rXE0a__pillOpen",
  "real": "LiveActivity-module__1rXE0a__real",
  "root": "LiveActivity-module__1rXE0a__root",
  "row": "LiveActivity-module__1rXE0a__row",
  "row-flash": "LiveActivity-module__1rXE0a__row-flash",
  "rowFresh": "LiveActivity-module__1rXE0a__rowFresh",
  "sim": "LiveActivity-module__1rXE0a__sim",
  "source": "LiveActivity-module__1rXE0a__source",
  "time": "LiveActivity-module__1rXE0a__time",
});
